<template>
  <div>
    <h4>Общее количество очков</h4>

    <table class="mb-4">
      <tr>
        <th>Цель</th>
        <td>{{ goal | getFormattedNumber }}</td>
        <td>100%</td>
        <td/>
      </tr>
      <tr>
        <th>Реальное значение</th>
        <td>{{ realValue | getFormattedNumber }}</td>
        <td>{{ realValuePercentStr }}</td>
        <td/>
      </tr>
      <tr>
        <th>Поправка</th>
        <td>{{ correction | getFormattedNumber }}</td>
        <td>{{ correctionPercentStr }}</td>
        <td>
          <router-link  v-if="canUserEditCorrection" :to="{name: 'season_common_score_correction_editor', params: {seasonId: seasonId}}">
            изменить
          </router-link>
        </td>
      </tr>
      <tr>
        <th>Исправленное значение</th>
        <td>
          {{ correctedValue | getFormattedNumber }}
        </td>
        <td>{{ correctedValuePercentStr }}</td>
        <td/>
      </tr>
      <tr>
        <td colspan="3" class="pt-2">
          <b-progress :max="goal" height="0.6em">
            <b-progress-bar :value="realValue" variant="success"/>
            <b-progress-bar :value="correction" variant="secondary"/>
          </b-progress>
        </td>
      </tr>
    </table>

    <table class="prop-table">
      <tr>
        <th>Время достижения 50%</th>
        <td>{{ time50PercentDone | getMomentStr }}</td>
      </tr>
      <tr>
        <th>Время достижения 100%</th>
        <td>{{ time100PercentDone | getMomentStr }}</td>
      </tr>
    </table>
    
  </div>
</template>

<script>
export default {
  name: 'SeasonCommonScore',

  props: {
    seasonId: {
      type: Number,
      required: true,
    },

    info: {
      type: Object,
      required: true,
    },

    canUserEditCorrection: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    /** @returns {number} */
    goal() {
      return this.info.goal;
    },

    /** @returns {number} */
    realValue() {
      return this.info.realValue;
    },

    /** @returns {string} */
    realValuePercentStr() {
      const realValuePercent = (this.realValue / this.goal) * 100;
      return realValuePercent.toFixed() + '%';
    },

    /** @returns {number} */
    correction() {
      const info = this.info;
      if(info.hasOwnProperty('correction')) {
        return info.correction;
      }

      return 0;
    },

    /** @returns {string} */
    correctionPercentStr() {
      const correctionPercent = (this.correction / this.goal) * 100;
      return correctionPercent.toFixed() + '%';
    },

    /** @returns {number} */
    correctedValue() {
      return this.realValue + this.correction;
    },

    /** @returns {string} */
    correctedValuePercentStr() {
      const correctedValuePercent = (this.correctedValue / this.goal) * 100;
      return correctedValuePercent.toFixed() + '%';
    },

    /** @returns {number} */
    time50PercentDone() {
      const info = this.info;
      if(!info.hasOwnProperty('time50PercentDone')) {
        return 0;
      }

      return info.time50PercentDone;
    },

    /** @returns {number} */
    time100PercentDone() {
      const info = this.info;
      if(!info.hasOwnProperty('time100PercentDone')) {
        return 0;
      }

      return info.time100PercentDone;
    },
  },
}
</script>

<style scoped>
th {
  padding-right: 0.5em;
  padding-bottom: .5rem;
}

td {
  padding-bottom: .5rem;
}

td:not(:last-child) {
  padding-right: 1em;
}

tr:last-child > th,
tr:last-child > td {
  padding-bottom: 0;
}

td {
  text-align: right;
}
</style>